import React, { Component } from "react";
import HomePageContent from "../components/page_content/HomePageContent";
import PageContainer from "../components/PageContainer";

export default class HomePage extends Component {
  render() {
    return (
      <PageContainer
       contentChild={<HomePageContent/>}
      />
    );
  }
}
